/**
 * Глобальный сигнал «нужно пополнить баланс»
 *
 * Любое место в приложении, поймавшее insufficient_funds от backend,
 * вызывает useTopUp.getState().open() - root-layout рендерит модальное
 * окно с текстом и кнопкой «Перейти к пополнению» (на /billing)
 */
import { create } from "zustand";

interface TopUpState {
  open: boolean;
  setOpen: (v: boolean) => void;
}

export const useTopUp = create<TopUpState>((set) => ({
  open: false,
  setOpen: (v) => set({ open: v }),
}));
